import WizardCard from './WizardCard.jsx';

// Reusable Y/N step. Used for both Devotional and Workout.
export default function StepYesNo({
  step,
  title,
  subtitle,
  value,
  onChange,
  onBack,
  onNext,
}) {
  function Choice({ label, choiceValue }) {
    const active = value === choiceValue;
    return (
      <button
        onClick={() => onChange(choiceValue)}
        className={`flex-1 py-4 rounded text-base font-medium transition border ${
          active
            ? 'bg-accent-blue text-white border-accent-blue'
            : 'bg-bg-input text-text-primary border-border-base hover:border-accent-blue/40'
        }`}
      >
        {label}
      </button>
    );
  }

  return (
    <WizardCard
      step={step}
      title={title}
      subtitle={subtitle}
      onBack={onBack}
      onNext={onNext}
      nextDisabled={value === null || value === undefined}
    >
      <div className="flex gap-3">
        <Choice label="Yes" choiceValue={true} />
        <Choice label="No" choiceValue={false} />
      </div>
    </WizardCard>
  );
}
